import { render, staticRenderFns } from "./StockInventorySurplusDispatcher.vue?vue&type=template&id=e7abc5f8&"
import script from "./StockInventorySurplusDispatcher.vue?vue&type=script&lang=js&"
export * from "./StockInventorySurplusDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField} from 'quasar'
component.options.components = Object.assign({QField}, component.options.components || {})
